(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-hotspot-image"] && !Shopify.designMode) return;
  try {
    class ShoppableImage extends HTMLElement {
    connectedCallback() {
      this.points = Array.from(this.querySelectorAll('.pc-hotspot__point'));
      this.img = this.querySelector('.pc-hotspot__img');
      this.media = this.querySelector('.pc-hotspot__media');
      this._update = this._update.bind(this);

      // Position the dots once we know the image's real dimensions...
      if (this.img) {
        if (this.img.complete && this.img.naturalWidth) {
          this._update();
        } else {
          this.img.addEventListener('load', this._update);
        }
      }
      // ...and keep them correct through resizes / breakpoint changes.
      if ('ResizeObserver' in window && this.media) {
        this._ro = new ResizeObserver(this._update);
        this._ro.observe(this.media);
      } else {
        window.addEventListener('resize', this._update);
      }

      this.querySelectorAll('.pc-hotspot__dot').forEach((dot) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          const point = dot.closest('.pc-hotspot__point');
          const isOpen = point.classList.contains('is-open');
          this._closeAll();
          if (!isOpen) {
            point.classList.add('is-open');
            dot.setAttribute('aria-expanded', 'true');
          }
        });
      });

      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) this._closeAll();
      });
    }

    disconnectedCallback() {
      if (this._ro) this._ro.disconnect();
    }

    _update() {
      this._reposition();
      this._alignCards();
    }

    // Map each authored image-relative coordinate (data-x/data-y, 0-100)
    // through object-fit: cover so the dot lands on the same spot of the
    // picture no matter how the container crops it.
    _reposition() {
      if (!this.img || !this.img.naturalWidth || !this.media) return;
      const w = this.media.clientWidth;
      const h = this.media.clientHeight;
      if (!w || !h) return;
      const r = (this.img.naturalWidth / this.img.naturalHeight) / (w / h);

      this.points.forEach((p) => {
        const fx = (parseFloat(p.dataset.x) || 50) / 100;
        const fy = (parseFloat(p.dataset.y) || 50) / 100;
        let left, top;
        if (r >= 1) {
          // Image wider than the box → cropped left/right.
          left = (fx * r - (r - 1) / 2) * 100;
          top = fy * 100;
        } else {
          // Image taller than the box → cropped top/bottom.
          const s = 1 / r;
          left = fx * 100;
          top = (fy * s - (s - 1) / 2) * 100;
        }
        p.style.left = left + '%';
        p.style.top = top + '%';
      });
    }

    _closeAll() {
      this.points.forEach((p) => {
        p.classList.remove('is-open');
        const dot = p.querySelector('.pc-hotspot__dot');
        if (dot) dot.setAttribute('aria-expanded', 'false');
      });
    }

    // Flip the popup toward the center / downward, based on where the dot
    // actually sits on screen after repositioning, so it never overflows.
    _alignCards() {
      this.points.forEach((p) => {
        const x = parseFloat(p.style.left) || 50;
        const y = parseFloat(p.style.top) || 50;
        if (x < 22) p.dataset.align = 'left';
        else if (x > 78) p.dataset.align = 'right';
        else delete p.dataset.align;
        if (y < 30) p.dataset.vertical = 'bottom';
        else delete p.dataset.vertical;
      });
    }
  }

  if (!customElements.get('shoppable-image')) {
    customElements.define('shoppable-image', ShoppableImage);
  }
  } catch(e) { console.error(e); }
})();

})();
